import { Injectable } from '@angular/core';
import { GenericService } from '../../../core/services/GenericService';
import { ApiService } from '../../../core/services';
import { IArticleVariant } from '../../../core/interfaces';
import { Observable } from 'rxjs';
import { ISimpleListItem } from 'src/app/core/interfaces/ISimpleListItem';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ArticlesVariantsService<T = IArticleVariant> extends GenericService<T> {

  protected readonly baseUrl = '/articles/variants';

  constructor(public apiService: ApiService) {
    super(apiService);
  }


  getSimpleList( search = ''): Observable<ISimpleListItem[]> {
    const params = new HttpParams()
      .append('search', `${search}`)
      .append('results', '50');
    return this.apiService.get(`${this.baseUrl}/simple`, params);
  }

  public addMhdOffer(
    articleVariantId: number,
    mhdOfferCounter: number,
    mhdOfferSalesPercent: number
  ): Observable<void> {
    return this.apiService.post(
      `${this.baseUrl}/add-mhd-offer`,
      { articleVariantId, mhdOfferCounter, mhdOfferSalesPercent }
    );
  }

  public deleteMhdOffer(articleVariantId: number): Observable<void> {
    return this.apiService.delete(`${this.baseUrl}/${articleVariantId}/mhd-offer`);
  }
}
